import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { getBrandConfig } from '@awaze/mfe-common.configs.brand'
import type { AccommodationType } from '@awaze/mfe-common.types-and-mocks.site-search-service'

import { DisplayMode } from '@/lib/display/displayContext'

export const getSortOptionsFromConfig = (
  accommodationType: AccommodationType | undefined,
  brand: Brand,
): string[] => {
  const brandConfig =
    accommodationType === 'cottages'
      ? getBrandConfig('cottages.com').sortOptions
      : getBrandConfig(brand).sortOptions

  return brandConfig.options
}

interface ShouldDisplaySortOptionsArgs {
  displayMode: DisplayMode
}

export const shouldDisplaySortOptions = ({
  displayMode,
}: ShouldDisplaySortOptionsArgs): boolean => displayMode === 'LIST'
